module.exports = "pegasus/assets/square-pinterest.gif";